import LocalizedStrings from 'localized-strings';

import { TeamMembersRequestStatus } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    amountLabel: 'Amount',
    approveRequest: 'Approve',
    callouts: {
      processing: {
        description:
          'The transfer is usually processed instantly but can take up to 24 hours.',
        title: 'Processing transfer',
      },
    },
    descriptionLabel: 'Description',
    exceededQuotaDescription:
      'The cost of sending this transfer is **{fees} excluding VAT.**',
    exceededQuotaTitle: 'Transfer fees',
    executionDateLabel: {
      [TeamMembersRequestStatus.Processed]: 'Requested on',
      [TeamMembersRequestStatus.Pending]: 'Requested on',
      [TeamMembersRequestStatus.Approved]: 'Requested on',
      [TeamMembersRequestStatus.Completed]: 'Executed on',
      [TeamMembersRequestStatus.Rejected]: 'Rejected on',
      [TeamMembersRequestStatus.Canceled]: 'Canceled on',
    },
    expenseClaim: 'Expense claim',
    insufficientFunds: 'Your account balance is insufficient',
    newBankTransferRecipient:
      'The recipient will be saved if you approve the transfer',
    recipientLabel: 'Recipient',
    refuseRequest: 'Refuse',
    requestApproved: 'The refund request has been validated',
    requestRejected: 'The refund request has been rejected',
    resellerLabel: 'Seller',
    strongAuthSidebarDescription:
      'Sensitive operations such as expense claims require your passcode.',
    vatRate: '{rate} % VAT',
  },
  fr: {
    amountLabel: 'Montant',
    approveRequest: 'Approuver',
    descriptionLabel: 'Description',
    exceededQuotaDescription:
      'L’envoi de ce virement est facturé **{fees} HT.**',
    exceededQuotaTitle: 'Frais de virement',
    executionDateLabel: {
      [TeamMembersRequestStatus.Processed]: 'Demandée le',
      [TeamMembersRequestStatus.Pending]: 'Demandée le',
      [TeamMembersRequestStatus.Approved]: 'Demandée le',
      [TeamMembersRequestStatus.Completed]: 'Exécutée le',
      [TeamMembersRequestStatus.Rejected]: 'Rejetée le',
      [TeamMembersRequestStatus.Canceled]: 'Annulée le',
    },
    expenseClaim: 'Note de frais',
    insufficientFunds: 'Le solde de votre compte est insuffisant',
    newBankTransferRecipient:
      'Le bénéficiaire sera enregistré si vous approuvez le virement',
    recipientLabel: 'Bénéficiaire',
    refuseRequest: 'Refuser',
    requestApproved: 'La demande de remboursement à bien été validée.',
    requestRejected: 'La demande de remboursement à été refusée.',
    resellerLabel: 'Vendeur',
    strongAuthSidebarDescription:
      'Les opérations sensibles comme les notes de frais nécessitent votre code secret.',
    vatRate: 'TVA {rate}\xa0%',
  },
} as const);

export default locales;
